import React from 'react';
import Reveal from '../Reveal';
import { upcomingReleases } from '../../mock';
import { scrollToId } from '../Navbar';
import { ArrowUpRight } from 'lucide-react';

// Seventy.blue "yachts for sale" grid — adapted as Riva's Upcoming Releases.
// These are not completed projects; each card clearly notes status (In Design /
// Pre-Design) and year. Clicking any card scrolls to Contact for enquiry.
export default function UpcomingReleases() {
  const onCardClick = (release) => {
    try {
      sessionStorage.setItem('rb_selected_release', release.name);
    } catch (e) {
      // noop
    }
    scrollToId('contact');
  };

  return (
    <section id="releases" className="bg-[#f4f1eb] py-24 md:py-36">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <Reveal className="text-center max-w-2xl mx-auto mb-16 md:mb-24">
          <div className="font-sans-ui text-[10px] tracking-[0.35em] text-[#5a5852] mb-6">
            Upcoming Releases
          </div>
          <h2 className="font-serif-display text-[38px] md:text-[54px] lg:text-[62px] tracking-wide lowercase text-[#2b2a27] leading-[1.05]">
            available
            <br />
            <em className="italic font-light">residences</em>
          </h2>
          <p className="mt-9 text-[14px] leading-[1.9] text-[#5a5852]">
            A small number of Riva-led residences currently in design across
            Los Angeles. Each is offered to a single family before ground-break;
            enquire for typology studies, siting and delivery timelines.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 md:gap-x-8 gap-y-16 md:gap-y-20">
          {upcomingReleases.map((r, idx) => (
            <Reveal key={r.id} delay={(idx % 3) * 120}>
              <button
                onClick={() => onCardClick(r)}
                className="group block w-full text-left"
              >
                <div className="relative overflow-hidden image-zoom">
                  <div className="aspect-[4/3]">
                    <img
                      src={r.image}
                      alt={r.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute top-4 left-4 md:top-5 md:left-5 font-sans-ui text-[9px] tracking-[0.28em] text-white bg-black/40 backdrop-blur-sm px-2.5 py-1">
                    {r.status}
                  </div>
                  <div className="absolute top-4 right-4 md:top-5 md:right-5 font-sans-ui text-[9px] tracking-[0.28em] text-white/95">
                    {r.year}
                  </div>
                </div>
                <div className="mt-6 flex items-start justify-between gap-4">
                  <div className="flex-1 space-y-1.5">
                    <div className="font-serif-display text-[20px] md:text-[22px] tracking-[0.15em] uppercase text-[#2b2a27] leading-tight">
                      {r.name}
                    </div>
                    <div className="text-[12px] text-[#5a5852] tracking-[0.1em]">
                      {r.location}
                    </div>
                    <div className="text-[12px] text-[#5a5852] italic">
                      {r.typology}
                    </div>
                    <div className="text-[12px] text-[#5a5852]">{r.size}</div>
                  </div>
                  <ArrowUpRight
                    size={18}
                    strokeWidth={1}
                    className="mt-1 text-[#2b2a27] opacity-60 group-hover:opacity-100 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                  />
                </div>
                <div className="mt-5 border-t border-[#c9c3b6]/70 pt-4">
                  <span className="font-serif-display italic text-[14px] text-[#2b2a27] underline-anim pb-0.5">
                    Enquire for details
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>

        <Reveal className="text-center mt-20 md:mt-24">
          <div className="max-w-xl mx-auto text-[13px] leading-[1.9] text-[#5a5852]">
            All releases are presented for qualified private enquiry only.
            Imagery is conceptual; each residence is developed to its specific
            site, client and programme.
          </div>
          <button
            onClick={() => scrollToId('contact')}
            className="mt-8 font-sans-ui text-[11px] tracking-[0.3em] border border-[#2b2a27] px-8 py-3 hover:bg-[#2b2a27] hover:text-[#f4f1eb] transition-colors"
          >
            Register Interest
          </button>
        </Reveal>
      </div>
    </section>
  );
}
